import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import { Link } from "react-router-dom";
import "./UpcomingEvents.css";

export default function UpcomingEvents() {
  const [upcomingData, setUpcomingData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const date = new Date();
    const data = await getContentById("upcomingEvents");
    let filteredData = data;
    filteredData = filteredData.filter((data) => new Date(data.date) > date);
    setUpcomingData(filteredData);
  };

  return (
    <div className="UpcomingEvents">
      <div className="upcomingHeader">
        <h1>
          UPCOMING
          <br />
          EVENTS
        </h1>
      </div>
      <div className="color"></div>
      <div className="upcomingButton">
        <Link to="calendar">
          <button>View Calendar</button>
        </Link>
      </div>
      <div className="upcomingBody">
        {upcomingData?.map((data) => (
          <div className="eventItems" key={data.id}>
            <h1>{data.date}</h1>
            <br />
            <p>{data.description}</p>
            <br />
            <img src="assets/Rectangle 18.png" alt="" />
          </div>
        ))}
      </div>
    </div>
  );
}
